<div class="flex flex-col items-center justify-center">
  <div class="mb-4">
    <img
      alt="Something went wrong"
      class="w-auto mx-auto"
      height="450"
      ngSrc="/assets/error.gif"
      width="450"
    />
  </div>
  <h2 class="text-xl font-semibold text-white text-center">Upps!</h2>
  <h2 class="text-xl font-semibold text-white mb-4 text-center">
    Da ist wohl etwas schief gelaufen...
  </h2>
  <p class="text-sm text-white text-center mb-4">
    Irgendwas klemmt beim Einlass. Versuch es mit einem Neuladen der Seite oder
    komm später nochmal vorbei. Falls du partout nicht reinkommst, gib uns
    Bescheid - wir setzen dich auf die Gästeliste!
  </p>
  <small class="text-xs font-extralight text-gray-300 text-center italic mb-2"
    >Für die Nerds: {{ error() }}</small
  >
</div>
